var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 888,
    height: 160,
    viewBox: "0 0 888 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 888,
    height: 160,
    rx: 10,
    fill: "#C6D7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.042 120C592.297 120.001 603.034 109.256 603.025 96.0016C603.017 82.7467 592.264 72.001 579.009 72.0003C565.755 71.9996 555.017 82.7442 555.026 95.999C555.035 109.254 565.787 120 579.042 120ZM579.034 109.417C586.444 109.417 592.448 103.41 592.443 95.9998C592.438 88.5893 586.426 82.5816 579.016 82.5813C571.605 82.5809 565.602 88.5879 565.607 95.9983C565.612 103.409 571.624 109.416 579.034 109.417Z",
    fill: "#97B4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.001 48C856.838 48.0005 863.996 40.8374 863.99 32.0009C863.984 23.1643 856.816 16.0005 847.98 16C839.143 15.9995 831.984 23.1626 831.99 31.9991C831.996 40.8357 839.165 47.9995 848.001 48ZM847.995 40.9445C852.936 40.9448 856.938 36.9401 856.935 31.9998C856.931 27.0595 852.924 23.0544 847.983 23.0542C843.043 23.0539 839.041 27.0586 839.044 31.9989C839.048 36.9392 843.055 40.9443 847.995 40.9445Z",
    fill: "#97B4F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0439 139C69.0643 139.001 82.0426 126.031 82.0318 110.03C82.021 94.0294 69.0252 81.0576 53.0049 81.0568C36.9845 81.0559 24.0062 94.0263 24.0169 110.027C24.0277 126.027 37.0235 138.999 53.0439 139ZM53.033 126.225C61.9898 126.226 69.2458 118.974 69.2398 110.028C69.2338 101.083 61.968 93.8304 53.0112 93.8299C44.0544 93.8294 36.7984 101.081 36.8044 110.027C36.8104 118.972 44.0762 126.225 53.033 126.225Z",
    fill: "#97B4F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBg);
export default __webpack_public_path__ + "static/media/banner-bg.472d47a84507bf220590c527b72a71a3.svg";
export { ForwardRef as ReactComponent };